import { Field } from './field';
import { OnInit, OnChanges, DoCheck, AfterContentInit, AfterContentChecked, AfterViewInit, OnDestroy, AfterViewChecked, SimpleChanges } from '@angular/core';
import { FormlyLifeCycleOptions, FormlyLifeCycleFn } from './../components/formly.field.config';
/**
 * @abstract
 */
export abstract class FieldType extends Field implements OnInit, OnChanges, DoCheck, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked, OnDestroy {
/**
 * @return {?}
 */
ngOnInit() {
    this.lifeCycleHooks(this.lifecycle.onInit);
  }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    this.lifeCycleHooks(this.lifecycle.onChanges);
  }
/**
 * @return {?}
 */
ngDoCheck() {
    this.lifeCycleHooks(this.lifecycle.doCheck);
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    this.lifeCycleHooks(this.lifecycle.afterContentInit);
  }
/**
 * @return {?}
 */
ngAfterContentChecked() {
    this.lifeCycleHooks(this.lifecycle.afterContentChecked);
  }
/**
 * @return {?}
 */
ngAfterViewInit() {
    this.lifeCycleHooks(this.lifecycle.afterViewInit);
  }
/**
 * @return {?}
 */
ngAfterViewChecked() {
    this.lifeCycleHooks(this.lifecycle.afterViewChecked);
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    this.lifeCycleHooks(this.lifecycle.onDestroy);
  }
/**
 * @return {?}
 */
private get lifecycle(): FormlyLifeCycleOptions {
    return this.field.lifecycle || {};
  }
/**
 * @param {?} callback
 * @return {?}
 */
private lifeCycleHooks(callback: FormlyLifeCycleFn) {
    if (callback) {
      callback.bind(this)(this.form, this.field, this.model, this.options);
    }
  }
}
